export interface SeasonTier {
  id: string;
  name: string;
  min: number;
  badge: string;
  color: string;
}

/** Season tiers — based on Club Points earned in the active season (calendar year). */
export const SEASON_TIERS: SeasonTier[] = [
  { id: 'legend', name: 'Legend', min: 500, color: '#c4a662', badge: '👑' },
  { id: 'champion', name: 'Champion', min: 300, color: '#0a1e3f', badge: '🏆' },
  { id: 'contender', name: 'Contender', min: 150, color: '#397c52', badge: '⭐' },
  { id: 'regular', name: 'Regular', min: 50, color: '#6f4e2c', badge: '⛳' },
  { id: 'rookie', name: 'Rookie', min: 0, color: '#8a8073', badge: '🎯' },
];

export function getSeasonYear(date = new Date()): number {
  return date.getFullYear();
}

export function seasonLabel(year: number): string {
  return `${year} Season`;
}

export function seasonDateRange(year: number): { start: Date; end: Date } {
  return {
    start: new Date(year, 0, 1),
    end: new Date(year + 1, 0, 1),
  };
}

export function getSeasonTier(seasonPoints: number): SeasonTier {
  return SEASON_TIERS.find((t) => seasonPoints >= t.min) || SEASON_TIERS[SEASON_TIERS.length - 1];
}

export function pastSeasonYears(currentYear = getSeasonYear(), count = 3): number[] {
  return Array.from({ length: count }, (_, i) => currentYear - i - 1);
}
